export function findClosestScrollParentY(element) {
    while (element) {
        const style = window.getComputedStyle(element);
        const overflowY = style.overflowY;
        const overflow = style.overflow;

        if (
            overflowY === 'auto' ||
            overflowY === 'scroll' ||
            overflow === 'auto' ||
            overflow === 'scroll'
        ) {
            return element;
        }

        element = element.parentElement;
    }

    return null;
}
